import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Contact from './Contact';
import MapEmbed from './MapEmbed';
import company from '../config/company';
import usePageMeta, {breadcrumbJsonLd} from '../seo/usePageMeta';
import './Pages.css';
import './ContactPage.css';

const ContactPage = () => {
  const jsonLd = useMemo(
    () => breadcrumbJsonLd([{name: 'Startseite', path: '/'}, {name: 'Kontakt', path: '/kontakt'}]),
    []
  );

  usePageMeta({
    title: 'Kontakt und Beratung | Cura Care Pflegedienst Eitorf',
    description: `Kostenlos beraten lassen: Telefon ${company.phone}, ${company.openingHours.label}, 24h-Rufbereitschaft. ${company.legalName}, ${company.street}, ${company.zip} ${company.city}.`,
    path: '/kontakt',
    jsonLd
  });

  return (
    <div className="page-view contact-page">
      <Header />
      <main className="page contact-page__main" id="kontaktaufnahme">
        <div className="page__inner">
          <section className="page-section">
            <nav className="breadcrumb" aria-label="Brotkrumen">
              <Link to="/">Startseite</Link>
              <span aria-hidden="true">/</span>
              <span>Kontakt</span>
            </nav>
            <div className="page__header">
              <p className="kicker">Kontakt</p>
              <h1>Kostenlos beraten lassen</h1>
              <p>
                Wir freuen uns darauf, von Ihnen zu hören. Nutzen Sie unser Kontaktformular oder
                rufen Sie uns an. Gemeinsam finden wir die passende Lösung für die Versorgung
                in Eitorf und Umgebung.
              </p>
              <div className="contact-page__quick">
                <a className="btn btn--primary" href={`tel:${company.phoneIntl}`}>{company.phone}</a>
                <a className="btn btn--ghost" href={`mailto:${company.email}`}>{company.email}</a>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Contact />

      <section className="contact-page__info" aria-label="Weitere Kontaktmöglichkeiten">
        <div className="contact-page__info-inner">
          <div>
            <h2>Telefonisch erreichbar</h2>
            <p>
              Sie erreichen uns {company.openingHours.label.replace('Montag bis Freitag', 'montags bis freitags')} unter{' '}
              <a href={`tel:${company.phoneIntl}`}>{company.phone}</a>. Für dringende Anliegen ist
              unsere Rufbereitschaft rund um die Uhr unter derselben Nummer erreichbar.
            </p>
          </div>
          <div>
            <h2>Vor Ort besuchen</h2>
            <p>
              {company.legalName}<br />
              {company.street}<br />
              {company.zip} {company.city}
            </p>
          </div>
          <div>
            <h2>Einzugsgebiet</h2>
            <p>
              Wir sind für Kundinnen und Kunden in Eitorf und Umgebung da und besprechen
              mit Ihnen gern, ob eine Versorgung an Ihrem Wohnort möglich ist.
            </p>
          </div>
          <div>
            <h2>So starten wir</h2>
            <p>
              Erstkontakt, kurze Bedarfsklärung, persönliche Abstimmung und dann die
              gemeinsame Planung der nächsten Schritte.
            </p>
          </div>
        </div>
      </section>

      <section className="contact-page__map" aria-labelledby="anfahrt-title">
        <div className="contact-page__map-inner">
          <div className="contact-page__map-text">
            <p className="kicker">So finden Sie uns</p>
            <h2 id="anfahrt-title">Unser Büro in Eitorf</h2>
            <p>
              {company.street}, {company.zip} {company.city}. Die Karte wird erst nach Ihrer
              Zustimmung geladen.
            </p>
          </div>
          <MapEmbed />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
